import {DateTime, DateTimeFormatOptions} from "luxon";


export const DateTimeFormat = {
  DAY_TIME_SERIAL: 'yLLddHHmm',           // 201401010900
  DAY_SERIAL: 'yLLdd',                    // 20140101
  SLOT_UI: "ccc L/d 'at' h:mm a ZZZZ",    // Wed 6/5 at 9:00 AM EDT
  SLOT_READER: "cccc, LLLL d 'at' h:mm a ZZZZ",    // Wed 6/5 at 9:00 AM EDT
  WEEKDAY_ABREV_MMDD_UI: "ccc L/d",       // Wed 6/5
  WEEKDAY_MMDD_UI: "cccc L/d",            // Wednesday 6/5
  TIME_SIMPLE_PLUS_ZONE: "h:mm a ZZZZ",   // 1:30 PM EDT
  DATE_START_TIME: "L/d/y, h:mm",         // 12/22/2023, 12:00
  _START_DATE: 'ccc LLL d',
  _END_TIME_AND_ZONE: 't ZZZZ',
  HOUR_MIN:'h:mm',
  HOUR_MIN_AMPM:'h:mm a',
  SHORT_MONTH_DAY:'M/d',
  TZ:"ZZZZ",
  EFFICIENT_DATE_AND_TIME: "L/d/y, h:mma",         // 12/22/2023, 12:00 am


}


/**
 *
 */
export const DateTimeHelpers = {

  y2k() {
    return DateTime.fromISO('2000-01-01');
  },

  sortDateTimes(dateTimes:DateTime[]):void {
    dateTimes.sort((a, b) => a < b ? -1 : a > b ? 1 : 0);
  },

  sortObjectsByProperty(objects:any[], propertyName:string, reverse?:boolean):void {
    if(objects && objects.length > 1) {
      if(objects[0].hasOwnProperty(propertyName)) {
        objects.sort((a,b)=> {
          const dateA = DateTimeHelpers.parseDateTime(a[propertyName]);
          const dateB = DateTimeHelpers.parseDateTime(b[propertyName]);
            if (dateA === null && dateB === null) {
              return 0;
            } else if (dateA === null) {
              return reverse?-1:1;
            } else if (dateB === null) {
              return reverse?1:-1;
            } else if (dateA > dateB) {
              return reverse?-1:1;
            } else if (dateA < dateB) {
              return reverse?1:-1;
            } else {
              return 0;
            }
          }
        );
      }
    }
  },

  toLocaleString(src:string|Date|DateTime|null, localeString:DateTimeFormatOptions, tz:string|null) {
    try {
      const asDateTime = DateTimeHelpers.parseDateTime(src);
      if(null!==asDateTime) {
        return tz ? asDateTime.setZone(tz).toLocaleString(localeString) : asDateTime.toLocaleString(localeString);
      }
    } catch(reason) {
      console.log(reason);
    }
    return "";
  },

  format(src:string|Date|DateTime|null, format:string, tz:string|null):string {
    try {
      const asDateTime = DateTimeHelpers.parseDateTime(src);
      if(null!==asDateTime) {
        return tz ? asDateTime.setZone(tz).toFormat(format) : asDateTime.toFormat(format);
      }
    } catch(reason) {
      console.log(reason);
    }
    return "";
  },

  /**
   * Safely create a luxon date from a Javascript Date or an ISO string representing a Date
   *
   * @param src
   */
  parseDateTime(src:string|Date|null|undefined|DateTime, debug?:boolean):DateTime|null {
    if(debug) {
      console.log("\n-----------\nparseDateTime", src);
    }
    try {
      if(undefined===src || null===src) {
        return null;
      } else {
        if(src instanceof DateTime) {
          if(debug) { console.log("parseDateTime - is already DateTime"); }
          return src;
        } else if(src instanceof Date) {
          const parsed = DateTime.fromJSDate(src);
          if(debug) { console.log("parseDateTime - Date", parsed); }
          return parsed;
        } else {
          const parsed = DateTime.fromISO(src);
          if(debug) { console.log("parseDateTime - String", parsed); }
          return parsed;
        }
      }
    } catch(reason) {
      console.log("DateHelpers.parseDateTime", reason, src);
      return null;
    }
  },

  parseDateTimeOr(src:string|Date|null, failureResult:DateTime):DateTime {
    if(src) {
      const result = DateTimeHelpers.parseDateTime(src);
      if(null!==result) {
        return result;
      }
    }
    return failureResult;
  },

  monthDayOrdinal(src:string|Date|DateTime|null) {
    try {
      const asDateTime = DateTimeHelpers.parseDateTime(src);
      if(null!==asDateTime) {
        const day = asDateTime.toFormat("d");
        return asDateTime.toFormat("LLLL ")+ordinal(day);
      }
    } catch(reason) {
      console.log(reason);
    }
    return "";
  }

}


function ordinal(n) {
  const s = ["th", "st", "nd", "rd"];
  const v = n%100;
  return n + (s[(v-20)%10] || s[v] || s[0]);
}


